// extracted by css-extract-rspack-plugin
export default {"logo":"BBnp6","shadow":"wCqIF"};